'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$00247 from "./presto.-Two-Factor-Auth-View$$anon$7.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$6(outer) {
  this.bFx = null;
  this.bFv = null;
  this.bFw = false;
  this.bFt = null;
  this.bFu = false;
  this.bFy = false;
  this.bFz = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bFx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$6 as $c_Lpresto_TwoFactorAuthView$$anon$6 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$6;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$6() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$6 as $h_Lpresto_TwoFactorAuthView$$anon$6 };
$h_Lpresto_TwoFactorAuthView$$anon$6.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bFx;
});
$p.t = (function() {
  if ((!this.bFw)) {
    this.bFv = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("seeds", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("invites", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bFw = true;
  }
  return this.bFv;
});
$p.ae = (function() {
  if ((!this.bFu)) {
    this.bFt = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$00247.$c_Lpresto_TwoFactorAuthView$$anon$7()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().p8()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bFu = true;
  }
  return this.bFt;
});
$p.w = (function() {
  if ((!this.bFz)) {
    this.bFy = false;
    this.bFz = true;
  }
  return this.bFy;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_TwoFactorAuthView$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$6, "presto.TwoFactorAuthView$$anon$6", ({
  SX: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$6 as $d_Lpresto_TwoFactorAuthView$$anon$6 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$6.js.map
